<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Akce</label>
    <div class="input">
      <div class="checklist">
        <div class="checklist-item" *ngFor="let action of actions" (click)="inputData.action = action.id; updated()">
          <gmt-radio [gmtChecked]="inputData.action === action.id"></gmt-radio> {{ action.name }}
        </div>
      </div>
    </div>
  </div>
  <div class="column-100" *ngIf="inputData.action === FinalSolutionStateEnum.REJECTED">
    <label class="required">Důvod zamítnutí</label>
    <textarea [(ngModel)]="inputData.note" (ngModelChange)="updated()" rows="4"></textarea>
  </div>
</fieldset>
